import { usePollReportStatus } from '../hooks/usePollReportStatus'
import { Spinner } from './Spinner'

export function Pending() {
  usePollReportStatus()

  return (
    <div className='pending'>
      <div>
        <h3>Scoring your listing’s quality...</h3>
        <p className='medium'>Analyzing popular keywords</p>
      </div>
      <div className='spinner'>
        <Spinner size={36} />
      </div>
      <div>
        <p className='small'>About 3 minutes remaining.</p>
        <p className='small'>
          No need to stay here! We’ll keep working, even if you close this tab.
        </p>
      </div>
    </div>
  )
}
